export const DEFAULT_LOCALE = 'en-GB'

export const VALID_LOCALES = ['en-GB', 'en-US', 'es']
